import React from 'react';
import IconWrapper from '@/shared/components/UI/IconWrapper';
import InfoIcon from '@/shared/icons/InfoIcon';

const ChatbotInactiveBadge = ({ className = '' }) => {
  return (
    <div
      className={`flex h-v3-lg items-center gap-[8px] rounded-v3-sm border border-v3-card-border py-v3-xxs pl-v3-xs pr-[12px] no-wrap ${className}`}
    >
      <IconWrapper size={20}>
        <InfoIcon className="w-full h-full text-v3-red-dark" />
      </IconWrapper>
      <p className="text-v3-h10 font-medium text-v3-red-dark">
        AI Agent Inactive
      </p>
    </div>
  );
};

export default ChatbotInactiveBadge;
